angular.module('impactx.basket').controller('BasketTemplateMenuCtrl', [
    'basketTemplateMenu',
    BasketTemplateMenuCtrl]);

function BasketTemplateMenuCtrl(basketTemplateMenu)
{
    var self = this;
    this.basketTemplateMenu = basketTemplateMenu;
    this.basketTemplateMenu.refreshAllTemplates().then(function()
    {
        self.allOptions = [{label: basketTemplateMenu.actionTranslations.addToBasket, func: basketTemplateMenu.addTemplateToBasket}];
        self.editOptions = [{label: basketTemplateMenu.actionTranslations.addToBasket, func: basketTemplateMenu.addTemplateToBasket},
            {label: basketTemplateMenu.actionTranslations.rename, func: basketTemplateMenu.renameTemplate},
            {label: basketTemplateMenu.actionTranslations.delete,  func: basketTemplateMenu.deleteBasketTemplate}];
    });

}